import { DISTRIBUTION_URL, LABEL_URL } from '../../services/common-urls';
import {
  createHttpGetOptions,
  getBaseUrl,
  MHTTPCL,
} from "../../services/http/http-client";

function findModule(url) {
  const parts = url.split('/').filter(Boolean);
  const moduleIndex = parts.indexOf('main');

  if (moduleIndex === -1) {
    return { module: null, submodule: null };
  }

  const module = parts[moduleIndex + 1] || null;
  const submodule = parts[moduleIndex + 2] || null;

  return { module, submodule };
}

export const DTTemplateAPI = {

  findTemplateList: ({ module, submodule, external_id }) => {

    const url = '/main/catalog/products/168/overview';

    const getTemplates = res => res.data.templates || [];
    const getBookingtemplates = res => res.data.bookingtemplates || [];

    // Catalog Releases
    // https://dev.berlin3.com/designcheck/label.pl?section=releases&
    // action=release_template_modal&
    // release_id=133&
    // output=json
    // templates
    if (module === 'catalog' && submodule === 'releases') {
      return MHTTPCL.get(LABEL_URL, {
        section: 'releases',
        action: 'release_template_modal',
        release_id: external_id
      }).then(getTemplates)
    }

    // Catalog Products
    // https://dev.berlin3.com/designcheck/label.pl?section=products&
    // action=view_label_product_overview_print_slect_template&
    // section_name=label&
    // product_id=168&
    // output=json
    // bookingtemplates

    if (module === 'catalog' && submodule === 'products') {
      return MHTTPCL.get(LABEL_URL, {
        section: 'products',
        action: 'view_label_product_overview_print_slect_template',
        section_name: 'label',
        product_id: external_id
      }).then(getBookingtemplates)
    }

    // Catalog Product Groups
    // https://dev.berlin3.com/designcheck/label.pl?section=product_groups&
    // action=templates_modal&
    // product_group_id=5&
    // output=json
    // templates

    if (module === 'catalog' && submodule === 'product_groups') {
      return MHTTPCL.get(LABEL_URL, {
        section: 'product_groups',
        action: 'templates_modal',
        product_group_id: external_id
      }).then(getTemplates)
    }

    // Roaylty Account
    // https://dev.berlin3.com/designcheck/distribution.pl?section=orders&
    // action=view_order_proforma_invoice_select_template&
    // template_section=royalty_account&
    // controller_name=label.pl&
    // section_name=royalty&
    // action_name=royalty_contract_report&
    // identifier=royalty_account_id&
    // id=2125&
    // rndval=1706787953230
    // bookingtemplates

    if (module === 'royalty' && submodule === 'royalty_accounts') {
      return MHTTPCL.get(DISTRIBUTION_URL, {
        section: 'orders',
        action: 'view_order_proforma_invoice_select_template',
        template_section: 'royalty_account',
        controller_name: 'label.pl',
        section_name: 'royalty',
        action_name: 'royalty_contract_report',
        identifier: 'royalty_account_id',
        id: external_id,
      }).then(getBookingtemplates)
    }

    // Royalty Contracts
    // https://dev.berlin3.com/designcheck/distribution.pl?action=view_order_proforma_invoice_select_template&
    // section=orders&
    // template_section=royalty_contract&
    // section_name=royalty&
    // controller_name=label.pl&
    // action_name=royalty_contract_report&
    // identifier=contract_id&
    // id=292&
    // output=json
    // bookingtemplates

    if (module === 'royalty' && submodule === 'contracts') {
      return MHTTPCL.get(DISTRIBUTION_URL, {
        section: 'orders',
        action: 'view_order_proforma_invoice_select_template',
        template_section: 'royalty_contract',
        section_name: 'royalty',
        controller_name: 'label.pl',
        action_name: 'royalty_contract_report',
        identifier: 'contract_id',
        id: external_id,
      }).then(getBookingtemplates)
    }

    // Distribution Orders
    // https://dev.berlin3.com/designcheck/distribution.pl?section=orders&
    // action=view_order_proforma_invoice_select_template&
    // template_section=label&
    // order_id=1946&
    // output=json
    // bookingtemplates

    if (module === 'distribution' && submodule === 'orders') {
      return MHTTPCL.get(DISTRIBUTION_URL, {
        section: 'orders',
        action: 'view_order_proforma_invoice_select_template',
        template_section: 'label',
        order_id: external_id
      }).then(getBookingtemplates)
    }

    // Supplier Orders
    // https://dev.berlin3.com/designcheck/distribution.pl
    // section	"supplier_orders"
    // action	"lable_templates" 
    // templates



    if (module === 'distribution' && submodule === 'supplier_order') {
      return MHTTPCL.get(DISTRIBUTION_URL, {
        section: 'supplier_orders',
        action: 'lable_templates',
      }).then(getTemplates)
    }
  },
  getTemplateText: ({ module, submodule, external_id }, template_id) => {
    // console.log({'dt-template.api.js:160 { module, submodule, external_id }' : { module, submodule, external_id }});

    if (module === 'catalog' && submodule === 'releases') {
      return templateTextAPI(LABEL_URL, {
        section: "releases",
        action: "render_release_template",
        booking_template_id: template_id,
        release_id: external_id,
      });
    }

    // https://dev.berlin3.com/designcheck/label.pl?section=products&action=view_label_product_overview_print&booking_template_id=723&product_id=158
    if (module === 'catalog' && submodule === 'products') {
      return templateTextAPI(LABEL_URL, {
        section: "products",
        action: "view_label_product_overview_print",
        booking_template_id: template_id,
        product_id: external_id,
      });
    }

    // https://dev.berlin3.com/designcheck/label.pl?section=product_groups&action=render_template&product_group_id=37&booking_template_id=559

    if (module === 'catalog' && submodule === 'product_groups') {
      return templateTextAPI(LABEL_URL, {
        section: "product_groups",
        action: "render_template",
        product_group_id: external_id,
        booking_template_id: template_id,
      });
    }

    // https://dev.berlin3.com/designcheck/label.pl?section=royalty&action=royalty_contract_report&booking_template_id=765&royalty_account_id=2133

    if (module === 'royalty' && submodule === 'royalty_accounts') {
      return templateTextAPI(LABEL_URL, {
        section: "royalty",
        action: "royalty_contract_report",
        booking_template_id: template_id,
        royalty_account_id: external_id,
      });
    }

    // https://dev.berlin3.com/designcheck/label.pl?section=royalty&action=royalty_contract_report&booking_template_id=764&contract_id=305

    if (module === 'royalty' && submodule === 'contracts') {
      return templateTextAPI(LABEL_URL, {
        section: "royalty",
        action: "royalty_contract_report",
        booking_template_id: template_id,
        contract_id: external_id,
      });
    }

    // https://dev.berlin3.com/designcheck/distribution.pl?section=orders&action=view_order_proforma_invoice&booking_template_id=736&order_id=1947
    if (module === 'distribution' && submodule === 'orders') {
      return templateTextAPI(DISTRIBUTION_URL, {
        section: "orders",
        action: "view_order_proforma_invoice",
        booking_template_id: template_id,
        order_id: external_id,
      });
    }

    // https://dev.berlin3.com/designcheck/distribution.pl?section=supplier_orders&action=displayOrderNotification&supplier_order_id=240&booking_template_id=609

    if (module === 'distribution' && submodule === 'supplier_order') {
      return templateTextAPI(DISTRIBUTION_URL, {
        section: "supplier_orders",
        action: "displayOrderNotification",
        supplier_order_id: external_id,
        booking_template_id: template_id,
      });
    }
  }
}

function templateTextAPI(apiModule, externalArgs) {
  return MHTTPCL.get(
    apiModule,
    externalArgs,
    createHttpGetOptions({
      noJsonOutput: true,
      responseType: "text",
    })
  ).then((res) => {
    // console.log({ 'dt-template.api.js:248 res': res });
    return res.data;
  });
}
